var map = {
	"./ellipse1.png": 3706,
	"./ellipse10.png": 373,
	"./ellipse11.png": 287,
	"./ellipse12.png": 6470,
	"./ellipse12_mobile.png": 5017,
	"./ellipse13.png": 7439,
	"./ellipse14.png": 507,
	"./ellipse1_mobile.png": 389,
	"./ellipse2_mobile.png": 5963,
	"./ellipse3_mobile.png": 9150,
	"./ellipse4_mobile.png": 3956,
	"./ellipse5_mobile.png": 2416,
	"./ellipse6_mobile.png": 9049,
	"./ellipse7.png": 7028,
	"./ellipse8.png": 9127,
	"./ellipse9.png": 4715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7877;